export const update = (data) => ({
  type: "USER/UPDATE",
  payload: data,
});

export const clear = () => ({
  type: "USER/CLEAR",
  payload: {},
});
